import React from "react";
import { GoDotFill } from "react-icons/go";
import { FaUserMd } from "react-icons/fa";
import { BsCheckCircle, BsClock } from "react-icons/bs";

const appointments = [
    {
        "Appointment ID": "APP0001",
        "Patient Name": "Lokesh",
        "Time Slot": "10:00 AM",
        "Doctor": "Dr. Hemanth",
        "Reason for Visit": "General Checkup",
        "Visit Type": "In-person",
        "Status": "Completed",
  
      },
      {
        "Appointment ID": "APP0002",
        "Patient Name": "Jhansi",
        "Time Slot": "11:00 AM",
        "Doctor": "Dr. Mounika",
        "Reason for Visit": "Follow-up",
        "Visit Type": "Virtual",
        "Status": "Upcoming"
      },
      {
        "Appointment ID": "APP0003",
        "Patient Name": "Kiran",
        "Time Slot": "1:30 PM",
        "Doctor": "Dr. Smitha",
        "Reason for Visit": "Diagnosis",
        "Visit Type": "In-person",
        "Status": "Completed"
      },
      {
        "Appointment ID": "APP0004",
        "Patient Name": "Mahesh",
        "Time Slot": "3:00 PM",
        "Doctor": "Dr. Sanju",
        "Reason for Visit": "General Checkup",
        "Visit Type": "Virtual",
        "Status": "Upcoming"
      },
      {
        "Appointment ID": "APP0005",
        "Patient Name": "Kakshayaini",
        "Time Slot": "4:45 PM",
        "Doctor": "Dr. Smitha",
        "Reason for Visit": "Follow-up",
        "Visit Type": "In-person",
        "Status": "Completed"
      },
      {
        "Appointment ID": "APP0006",
        "Patient Name": "Anusha",
        "Time Slot": "9:00 AM",
        "Doctor": "Dr.  Sanju",
        "Reason for Visit": "Diagnosis",
        "Visit Type": "Virtual",
        "Status": "Upcoming"
      },
      {
        "Appointment ID": "APP0007",
        "Patient Name": "Sravani",
        "Time Slot": "10:15 AM",
        "Doctor": "Dr. Smitha",
        "Reason for Visit": "General Checkup",
        "Visit Type": "In-person",
        "Status": "Completed"
      },
      {
        "Appointment ID": "APP0008",
        "Patient Name": "Sai Lakshmi",
        "Time Slot": "2:30 PM",
        "Doctor": "Dr. Kiran",
        "Reason for Visit": "Follow-up",
        "Visit Type": "Virtual",
        "Status": "Upcoming"
      },
      {
        "Appointment ID": "APP0009",
        "Patient Name": "Janu",
        "Time Slot": "12:00 PM",
        "Doctor": "Dr. Smitha",
        "Reason for Visit": "Diagnosis",
        "Visit Type": "In-person",
        "Status": "Completed"
      },
      {
        "Appointment ID": "APP0010",
        "Patient Name": "Rachel ",
        "Time Slot": "3:45 PM",
        "Doctor": "Dr. Riya",
        "Reason for Visit": "General Checkup",
        "Visit Type": "Virtual",
        "Status": "Upcoming"
      },
      {
        "Appointment ID": "APP0011",
        "Patient Name": "Komal",
        "Time Slot": "11:30 AM",
        "Doctor": "Dr. Smitha",
        "Reason for Visit": "Follow-up",
        "Visit Type": "In-person",
        "Status": "Completed"
      },
];

const TodaysAppointmentGrid = () => {
  return (
    <div className="row">
      {appointments.map((appointment) => (
        <div className="col-sm-4 mb-3" key={appointment["Appointment ID"]}>
          <div
            className="card shadow-sm"
            style={{
              borderRadius: "12px",
              border: "1px solid #ddd",
            }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-between align-items-center pb-2"
                style={{
                  borderBottom: "2px dashed #6b93b0",
                  paddingBottom: "8px",
                }}
              >
                <h6
                  style={{
                    color: "grey",
                    fontWeight: "bold",
                    fontSize: "12px",
                    margin: 0,
                  }}
                >
                  {appointment["Appointment ID"]}
                </h6>
                <div className="d-flex align-items-center">
                  <GoDotFill color={appointment.Status === "Completed" ? "green" : "#FFB800"} />
                  <p
                    className="mb-0"
                    style={{
                      color: appointment.Status === "Completed" ? "green" : "#FFB800",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {appointment.Status}
                  </p>
                </div>
              </div>

              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between">
                  <p className="mt-2 fw-bold" style={{ fontSize: "12px" }}>
                    Patient Name
                  </p>
                  <p className="mb-0 me-3" style={{ fontSize: "12px" }}>
                    {appointment["Patient Name"]}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mt-2 fw-bold" style={{ fontSize: "12px" }}>
                    Reason for Visit
                  </p>
                  <p
                    className="mb-0 me-3 fw-medium"
                    style={{ color: appointment["Reason for Visit"]==='General Checkup'?'green':appointment["Reason for Visit"]==='Follow-up'?'#FFB800':'#1AA7FF', fontSize: "12px" }}
                  >
                    {appointment["Reason for Visit"]}
                  </p>
                </div>
              </div>

              <div className="card" style={{ borderColor: "#09940b" }}>
                <div
                  className="card-header"
                  style={{
                    borderColor: "#09940b",
                    backgroundColor: "rgba(34, 201, 37,0.3)",
                    fontWeight: 600,
                  }}
                >
                  {appointment.Doctor}
                </div>
                <div className="card-body">
                  <div className="mt-2">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <BsCheckCircle color="#2ac7b2" size={16} />
                        <p
                          className="mb-0 ms-2 fw-bold"
                          style={{ fontSize: "12px" }}
                        >
                          Visit Type
                        </p>
                      </div>
                      <p className="mb-0 text-end" style={{ fontSize: "12px" }}>
                        {appointment["Visit Type"]}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-center">
                        <BsClock color="#36d413" size={16} />
                        <p
                          className="mb-0 ms-2 fw-bold"
                          style={{ fontSize: "12px" }}
                        >
                          Time Slot
                        </p>
                      </div>
                      <p className="mb-0 text-end" style={{ fontSize: "12px" }}>
                        {appointment["Time Slot"]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
        </div>
      ))}
    </div>
  );
};

export default TodaysAppointmentGrid;
